export default {
  // localStorage

  // 存贮 目前对象值如果是函数 、RegExp等特殊对象存贮会被忽略
  ls_set: (key, value) => {
    if (typeof value === 'object') {
      value = JSON.stringify(value)
    }
    localStorage.setItem(key, value)
  },

  // 获取
  ls_get: key => localStorage.getItem(key),

  // 移除
  ls_remove: key => {
    localStorage.removeItem(key)
  },

  // 存贮某一段时间失效 expire 过期时间,时间戳
  // ls_set_expire: (key, value, expire) => {
  //   if (typeof (value) === 'object') {
  //     value = JSON.stringify(value)
  //   }
  //   localStorage.setItem(key, value)
  //   setTimeout(() => {
  //     localStorage.removeItem(key)
  //   }, expire)
  // },

  ls_set_expire(key, value, hours = 1) {
    localStorage.setItem(
      key,
      JSON.stringify({
        value,
        expire: new Date().getTime() + hours * 3600 * 1000,
      })
    )
  },

  ls_get_expire(key) {
    const storage = JSON.parse(localStorage.getItem(key))
    if (storage.expire < new Date().getTime()) {
      localStorage.removeItem(key)
      return
    } else {
      return storage.value
    }
  },

  // sessionStorage

  // 存贮
  ss_set: (key, value) => {
    if (typeof value === 'object') {
      value = JSON.stringify(value)
    }
    sessionStorage.setItem(key, value)
  },

  // 获取
  ss_get: key => sessionStorage.getItem(key),

  // 移除
  ss_remove: key => {
    sessionStorage.removeItem(key)
  },

  // 存贮某一段时间失效 expire 过期时间,时间戳
  // ss_set_expire: (key, value, expire) => {
  //   if (typeof (value) === 'object') {
  //     value = JSON.stringify(value)
  //   }
  //   sessionStorage.setItem(key, value)
  //   setTimeout(() => {
  //     sessionStorage.removeItem(key)
  //   }, expire)
  // },

  ls_set_expire(key, value, hours = 1) {
    sessionStorage.setItem(
      key,
      JSON.stringify({
        value,
        expire: new Date().getTime() + hours * 3600 * 1000,
      })
    )
  },

  ls_get_expire(key) {
    const storage = JSON.parse(sessionStorage.getItem(key))
    if (storage.expire < new Date().getTime()) {
      sessionStorage.removeItem(key)
      return
    } else {
      return storage.value
    }
  },
}
